window.GatewayTeamLiveAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.tsGatewayTeamLiveServer : publicConfiguration.GatewayTeamLiveServer );


    self.getEmployerTimesheetSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/timesheets/settings', 'GET').then(function (result) {
            if (result && result.data && result.data.data && result.status === 200) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.recalculateBreaks = function (brandId, userId, day, payLoad) {
        var deferred = $q.defer();
        _protected.uniqueRequest('breaks/brands/' + brandId + '/users/'+ userId + '/calculate'+'?day=' + day , 'POST', payLoad)
            .then(function (result) {
            if (result && result.data && result.data.data && result.status === 200) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    }

    self.getEmployerOffersSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/offers/settings', 'GET').then(function (result) {
            if (result && result.data && result.data.data && result.status === 200) {
                deferred.resolve(result.data.data.settings);
            } else {
                deferred.reject(result);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.checkPendingActualConsentsCount = function (brandId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/users/shifts/consents/count?status=PENDING_EMPLOYEE_APPROVAL", "GET")
            .then(function (res) {
                if (res && res.data && res.status == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    self.getBrandDetails = function (brandId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/settings", "GET")
            .then(function (res) {
                if (res && res.data && res.status == 200) {
                    deferred.resolve(res.data.data.brands);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getBrandTimesheet = function (brandId, type, day) {
        var deferred = $q.defer();

        var params = {
            type: type,
            day: day
        };

        _protected.request('brands/' + brandId + '/timesheets', 'GET', params, false).then(function (res) {
            if (res.status == 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    const [getBrandsSettingsV3] = cacheService.cache(function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This API required a brand id ' + brandId;
        }
        _protected.uniqueRequest("api/v3/brands/" + brandId + "/settings", "POST", payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.brands || []);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    });

    self.getBrandsSettingsV3 = getBrandsSettingsV3;

    self.login = function (username, password, gCaptchaResponse) {
        var deferred = $q.defer();

        var params = {
            username: username,
            password: password,
            'g-recaptcha-response': gCaptchaResponse
        };

        _protected.request('api/v2/' + "login", "POST", params)
            .then(function (res) {
                    if (res.status == 200 && res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

};

GatewayTeamLiveAPI.OVERNIGHT_SETTINGS_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
};